import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "@/lib/cx";

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  children?: ReactNode;
  tone?: "neutral" | "accent" | "ink";
  active?: boolean;
};

const tones = {
  neutral: "bg-surface-inset text-text-body border-border-hairline",
  accent: "bg-signal-100 text-signal-700 border-signal-300",
  ink: "bg-surface-ink text-on-ink border-border-on-ink",
} as const;

/** Pill, mono uppercase. The only place `--radius-pill` is allowed. */
export function Tag({ children, tone = "neutral", active = false, onClick, className, ...rest }: TagProps) {
  return (
    <span
      onClick={onClick}
      className={cx(
        "inline-flex items-center gap-2 px-[11px] py-[5px]",
        "font-label text-label uppercase border rounded-pill",
        "transition-[background-color,border-color,color] duration-160 ease-out",
        active ? tones.ink : tones[tone],
        onClick ? "cursor-pointer hover:border-text-primary" : "cursor-default",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
